module.exports = __webpack_public_path__ + "img/question-icon.43d9e981.svg";